import { inject } from '@angular/core';
import { Observable, take } from 'rxjs';
import { AuthenticationService } from './authentication/authentication.service';

export function EntryGuard(): Observable<boolean> {
  const authService = inject(AuthenticationService);
  return authService.handleRedirect().pipe(take(1));
}
